import { render } from "./WagoLatestParamsPanel.vue?vue&type=template&id=5b93edd4&scoped=true&ts=true"
import script from "./WagoLatestParamsPanel.vue?vue&type=script&lang=ts"
export * from "./WagoLatestParamsPanel.vue?vue&type=script&lang=ts"

import "./WagoLatestParamsPanel.vue?vue&type=style&index=0&id=5b93edd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b93edd4"]])

export default __exports__